declare var System: any;

import * as _ from "lodash";
import {BaseApp, BaseAppOptions} from "./_BaseApp";


// The following Modules won't actually be emitted as "require" calls here
// since they are not used directly. Instead, they are only referenced
// with "typeof". At this point, these statements are only for the
// benefit of the TypeScript type system.
const BaseAppViewModule = require("./_BaseApp");

export class AppRegistry {

    private appDict: {[key: string]: BaseApp} = {};
    private appLoading: {[key: string]: {deferred: any, callbacks: any[]}} = {};

    constructor(public options: BaseAppOptions){}

    getInstance(appType: string, callback?: (Error, BaseApp) => void) {
        if(this.appDict[appType]) {
            if(callback) {
                return setTimeout(() => {
                    callback(null, this.appDict[appType])
                });
            } else {
                return $.Deferred().resolve(this.appDict[appType]);
            }
        }

        // Check if we are already loading the app. If so return the same deferred and add to the callback queue
        // otherwise create a new callback
        if(this.appLoading[appType]) {
            if(callback) this.appLoading[appType].callbacks.push(callback);

            // We are already loading the app. Bail
            return callback ? null : this.appLoading[appType].deferred;
        }

        var d = $.Deferred();
        this.appLoading[appType] = {
            deferred: d,
            callbacks: [callback]
        };

        System.import('./' + appType.toLowerCase() + '/App').then((AppViewModule: typeof BaseAppViewModule) => {
            this.appDict[appType] = new AppViewModule.App(_.extend({}, this.options, {
                appRegistry: this
            }));

            // Resolve the deferred and call all queued callbacks
            this.appLoading[appType].deferred.resolve(this.appDict[appType]);
            for(var i=0; i < this.appLoading[appType].callbacks.length; i++) {
                this.appLoading[appType].callbacks[i](null, this.appDict[appType]);
            }

            delete this.appLoading[appType];
        });

        if(!callback) return d;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/apps/AppRegistry.ts